import {useEffect, useState, Fragment} from 'react'
import is from 'is_js'
import _ from '@strings'
import {STEP_LOCATION} from '@names'
import {useDispatch, useSelector} from 'react-redux'
import {useGetSlots} from '@hooks'
import NoAppointment from '@components/Modules/NoAppointment'
import {loadStep, setAppointments, userSelectSlot} from '@store/actions/app'
import DateSelect from '@components/Modules/DateSelect/V2'
import TimeSelect from '@components/Modules/TimeSelect/V2'
import Loading from '@components/Ui/Loading'
import Error from '@components/Ui/Error'
import Button from '@components/Ui/Button'
import Text from '@components/Ui/Text'
import Spacer from '@components/Ui/Spacer'
import Row from '@components/Ui/Grid/Row'
import Column from '@components/Ui/Grid/Column'
import styles from './DateTimeSelect.scss'

const DateTimeSelect = ({ setValid }) => {
  const storedSlots     = useSelector((s) => s.appointments)
  const storeCode       = useSelector((s) => s.data.store.code)
  const templateId      = useSelector((s) => s.data.type.id)
  const mode            = useSelector((s) => s.data.mode)
  const preselectedDate = useSelector((s) => s.data.slot?.date)
  const preselectedTime = useSelector((s) => s.data.slot?.startTime)

  const [slots, error, loading]         = useGetSlots(storeCode, templateId, mode)
  const [timeSlots, setTimeSlots]       = useState([])
  const [selectedDate, setSelectedDate] = useState(preselectedDate)
  const [selectedTime, setSelectedTime] = useState(preselectedTime)
  const dispatch                        = useDispatch()

  const hasStoredSlots = is.not.empty(storedSlots || {})
  const hasSlots       = is.not.empty(slots || {}) || hasStoredSlots
  const showSlots      = hasStoredSlots ? storedSlots : slots
  const hasShownSlots  = is.not.empty(showSlots)

  useEffect(() => {
    if (selectedDate && selectedTime) {
      setValid(true)
    } else {
      setValid(false)
    }
  }, [selectedDate, selectedTime])

  useEffect(() => {
    if (!loading && is.not.empty(slots || {})) {
      dispatch(setAppointments(slots))
    }
  }, [slots, loading])

  useEffect(() => {
    if (selectedDate) {
      setTimeSlots(slots?.[selectedDate] || storedSlots?.[selectedDate])
    }
  }, [selectedDate])

  const onClickDay = (day) => {
    setSelectedDate(day)
    setSelectedTime(null)
    dispatch(userSelectSlot(null))

    setTimeSlots(slots?.[day])
  }

  const onClickTime = (slot) => {
    setSelectedTime(slot.startTime)
    dispatch(userSelectSlot(slot))
  }
  return (
    <div className={styles.base}>
      {loading && <Loading>{_('datetime.loading')}</Loading>}
      {error && <Error>{_('errors.api')}</Error>}
      {!loading && !hasSlots && (
        <Error>
          {_('datetime.no_results')}
          <Spacer vertical scale="0.5"/>
          <Button theme="outline" onClick={() => dispatch(loadStep(STEP_LOCATION))}>
            {_('datetime.no_results_button')}
          </Button>
        </Error>
      )}
      {!loading && (hasStoredSlots || hasSlots) && (
        <Fragment>
          <Text type="slab_md" center as="div">
            {_('datetime.headline')}
          </Text>
          <Spacer vertical scale="1"/>
          <Row>
            {hasShownSlots && (
              <Column size="6/12@md">
                <DateSelect
                  slots={showSlots}
                  selected={selectedDate}
                  selectDay={(day) => onClickDay(day)}
                />
              </Column>
            )}
            {selectedDate && (
              <Column size="6/12@md">
                <TimeSelect
                  slots={timeSlots}
                  selected={selectedTime}
                  selectedDate={selectedDate}
                  selectTime={(time) => onClickTime(time)}
                />
              </Column>
            )}
          </Row>
          <Spacer vertical scale="1"/>
          {mode === 'live' && <NoAppointment/>}
        </Fragment>
      )}
    </div>
  )
}

DateTimeSelect.defaultProps = {}
DateTimeSelect.propTypes    = {}

export default DateTimeSelect
